module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-700.woff?bc1e47a3976358aa868a72de5a85de5a";